import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

const html = `
  <slot></slot>
`;

/**
 * 
 * The link component adds styles to slotted text content
 * to make them appear as a link.
 *
 * @module components/link
 *  * 
 * @example
```html
<upd-moveiq-link>
  View Profile
</upd-moveiq-link>
```
 */
export default class Link extends withHTMLComponent(styles, html)() {}

customElements.define('upd-moveiq-link', Link);
